/* eslint-disable */
import decamelizeKeys from 'decamelize-keys-deep'
import camelcaseKeys from 'camelcase-keys-deep'
import decamelizeString from 'decamelize'

export const camelize = (obj) => camelcaseKeys(obj)

export const decamelize = (obj) => decamelizeKeys(obj)

export { decamelizeString }
